import React from "react";
import { useEffect } from "react";
function Contactus() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="contac_us_section pt-40 pb-40">
      <div className="container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-lg-6 col-md-6 col-sm-12 grid_col">
            <div className="inner-box">
              <h6>AAMMII THARCHARBU SANTHAI (Main Office)</h6>
              <p>
                No.49, Tirupathi Nagar, Near Perumal temple, Kovaipudur
                Coimbatore - 641042. Tamilnadu. India.
              </p>
              <p>Email : aammiisanthai@gmail.com</p>
              <p>Contact Us : +6012 3544988</p>
              <div>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3984.7937933904254!2d101.49953881058973!3d2.875770654760137!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cda55e282d7d07%3A0xc3b08422805bc05e!2s19%2C%20Jln%202%2F4%2C%20Taman%20Sri%20Jaromas%2C%2042600%20Jenjarom%2C%20Selangor%2C%20Malaysia!5e0!3m2!1sen!2sin!4v1742559124221!5m2!1sen!2sin"
                  width="600"
                  height="450"
                  style={{ border: "0" }}
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contactus;
